/* ═══════════════ GUY DOM ═══════════════
   Utility DOM condivise, esposte come window.GuyDom.
   Va caricato PRIMA di chiunque le usi (vedi ordine defer in theme.liquid).

   ── BLOCCO SCROLL ──
   Prima c'erano QUATTRO padroni della stessa serratura, con due tecniche
   diverse: modal-manager (position:fixed + offset, la sola che regge su iOS)
   e app.js / cartjs.js (body.style.overflow). Nessuno sapeva
   degli altri, quindi chi chiudeva per ultimo apriva a tutti:

     apri il menu mobile (blocca) → apri il cart drawer (blocca)
     → chiudi il menu → overflow='' e la pagina scorre DIETRO al drawer aperto.

   Qui la serratura è una sola, con un registro di chi l'ha chiesta: si apre
   solo quando l'ultimo la rilascia. Il registro è un Set di nomi, non un
   contatore, così una doppia chiamata dello stesso proprietario non lascia
   il blocco appeso (lock('menu') due volte + unlock('menu') una = sbloccato). */
(function () {
  'use strict';

  var owners = new Set();
  var scrollY = 0;

  function lockScroll(owner) {
    if (!owner) return;
    if (owners.size === 0) {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + scrollY + 'px';
      document.body.classList.add('modal-open');
    }
    owners.add(owner);
  }

  function unlockScroll(owner) {
    if (!owner || !owners.has(owner)) return;
    owners.delete(owner);
    if (owners.size > 0) return;              // qualcun altro tiene ancora aperto
    document.body.classList.remove('modal-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  /* Esegue cb quando l'ingresso nella pagina e' finito: se c'e' una
     transizione tra pagine (il morph del modello, ~0,45 s) aspetta la sua
     fine, altrimenti subito. Serve ai precaricamenti pesanti: partire durante
     il morph gli rubava banda e decodifica proprio nel momento piu' visibile.
     Rete di sicurezza: dopo 1,5 s parte comunque. */
  function afterEntrance(cb) {
    var done = false;
    var timer = setTimeout(go, 1500);
    function cancel() {
      done = true;
      clearTimeout(timer);
      window.removeEventListener('pagereveal', onReveal);
    }
    function go() { if (done) return; cancel(); cb(); }
    function fromReveal(r) {
      if (r && r.vt && r.vt.finished) {
        // Una transizione nota ha sempre finished, anche se viene saltata.
        // La rete di sicurezza serve solo se pagereveal non arriva.
        clearTimeout(timer);
        r.vt.finished.then(go, go);
      } else go();
    }
    function onReveal() { fromReveal(window.__guyReveal); }
    if (!crossDocVT) go();
    else if (window.__guyReveal) fromReveal(window.__guyReveal);
    else window.addEventListener('pagereveal', onReveal, { once: true });
    return cancel;
  }

  /* UN solo criterio per "questo browser fa le transizioni tra pagine":
     l'evento pagereveal (Chrome 123+, Safari 18.2+). Prima c'erano tre test
     diversi; 'startViewTransition' in document e' vero anche su Safari
     18.0-18.1, che pero' anima solo dentro la stessa pagina: li' non partiva
     ne' il morph ne' la dissolvenza di riserva, e il cambio pagina era un
     taglio netto. */
  var crossDocVT = typeof window.__guyCrossDocVT === 'boolean'
    ? window.__guyCrossDocVT : 'onpagereveal' in window;

  /* Un ingresso per attivazione della pagina, anche al ritorno dalla BFCache.
     pageshow puo' precedere pagereveal: sui browser con morph aspettiamo
     quest'ultimo, evitando di riusare la transizione della visita precedente. */
  function onEntrance(cb) {
    var entered = false;
    var cancel = null;
    function enter() {
      if (entered) return;
      entered = true;
      cancel = afterEntrance(cb);
    }
    window.addEventListener('pagehide', function () {
      entered = false;
      if (cancel) cancel();
    });
    window.addEventListener(crossDocVT ? 'pagereveal' : 'pageshow', enter);
    enter();
  }

  window.GuyDom = {
    crossDocVT: crossDocVT,
    lockScroll: lockScroll,
    unlockScroll: unlockScroll,
    afterEntrance: afterEntrance,
    onEntrance: onEntrance
  };
})();
